import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=0e3f417e&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
import style0 from "./Detail.vue?vue&type=style&index=0&id=0e3f417e&prod&lang=scss"
import style1 from "./Detail.vue?vue&type=style&index=1&id=0e3f417e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f417e",
  null
  
)

export default component.exports